import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { JuniorPilot, JuniorPilotInfo } from '@common/interfaces/mybooking/order-services.interface';
import { SupportComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';
import { GetOrderResponseData, Traveler, Type1 } from 'src/sdk-servicing';

@Component({
  selector: 'asw-junior-pilot-item',
  templateUrl: './junior-pilot-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JuniorPilotItemComponent extends SupportComponent implements AfterViewInit {
  @Input() flight!: Type1;
  @Input() traveler!: Traveler;
  @Input() pnr!: GetOrderResponseData;
  isShowContent: boolean = true;
  @ViewChild('juniorPilot') juniorPilotRef!: ElementRef;
  constructor(
    public change: ChangeDetectorRef,
    private commmon: CommonLibService,
    private _staticMsgPipe: StaticMsgPipe
  ) {
    super(commmon);
  }

  init(): void {}

  // [10.11] ジュニアパイロット申込状況
  get getJuniorPilotServiceStatus(): string {
    const juniorPilot = this.pnr?.services?.juniorPilot as JuniorPilot;
    const serviceStatus = juniorPilot?.[this.flight?.id as string]?.[this.traveler?.id as string]?.serviceStatus;
    // [10.1] 申込済み搭乗者情報.serviceStatus = requestedの場合、ジュニアパイロット申込が申込済みの旨
    if (JuniorPilotInfo.ServiceStatusEnum.Requested === serviceStatus) {
      return 'label.applied';
    }
    // [10.2] 申込済み搭乗者情報.serviceStatus = unnecessaryの場合、ケア不要が申込済みの旨
    if (JuniorPilotInfo.ServiceStatusEnum.Unnecessary === serviceStatus) {
      return 'label.ｎoＣareＲequiredApplied';
    }
    // [10.3] 申込済み搭乗者情報.serviceStatus = notRequestedの場合、未申込の旨
    if (JuniorPilotInfo.ServiceStatusEnum.NotRequested === serviceStatus) {
      return 'label.notRegistered';
    }
    return '';
  }

  ngAfterViewInit(): void {
    if (this.juniorPilotRef) {
      this.isShowContent = this.juniorPilotRef.nativeElement.childElementCount > 0;
      this.change.markForCheck();
    }
  }

  override destroy(): void {}
  override reload(): void {}
}
